import axios from "axios";

const API_URL = "https://supadaa.com/api/";

const authHeaders = (extra = {}) => ({
  Accept: "application/json",
  Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  ...extra,
});

// { status, slots: {1:{label,width,height},...}, data: [...] }
const getAll = async () => {
  const res = await axios.get(`${API_URL}collections`, { headers: authHeaders() });
  return res.data;
};

// formData: position, title, link, status, image?, mobile_image?, remove_mobile?
const save = async (formData) => {
  const res = await axios.post(`${API_URL}collections/save`, formData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });
  return res.data;
};

const remove = async (position) => {
  const res = await axios.post(
    `${API_URL}collections/delete`,
    { position },
    { headers: authHeaders({ "Content-Type": "application/json" }) }
  );
  return res.data;
};

export default { getAll, save, remove };